import { GzRmVulnerabilitiesBreakdownWidgetWebComponent } from './component/GzRmVulnerabilitiesBreakdownWidgetWebComponent';

export { GzRmVulnerabilitiesBreakdownWidgetWebComponent };
